import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { HeartBeat } from '../../models/heartbeat';
import { BikeService } from '../../services/bike.service';

import * as L from 'leaflet';
import 'leaflet.markercluster';

import { DEFAULT_LAT, DEFAULT_LONG } from '../../constants';
import { environment } from '../../../environments/environment';
@Component({
  selector: 'app-bike-history',
  templateUrl: './bike-history.component.html',
  styleUrls: ['./bike-history.component.css']
})
export class BikeHistoryComponent implements OnInit {
  @Input() bikeId: number;
  heartBeats: HeartBeat[];
  shouldShowBatteryColumn: boolean;

  /** leaflet options */
  options = {
    layers: [
      L.tileLayer(environment.osmUrl,
        { maxZoom: 24, attribution: 'Open Street Map' })
    ],
    zoom: 10,
    center: L.latLng(DEFAULT_LAT, DEFAULT_LONG)
  };

  map: L.Map;

  /* binded map properties */
  center: L.LatLng = this.options.center;
  zoom: number = this.options.zoom;
  fitBounds: any;

  /** markers to display on map array */
  markers: any[] = [];


  constructor(public bikeService: BikeService) { }

  /**
   * Get the last heartbeats for the selected bike and initialise the map
   */
  ngOnInit() {
    this.bikeService.getHeartBeat(this.bikeId).subscribe(res => {
      this.heartBeats = res;
      this.shouldShowBattery();
      this.markPositions();
      this.centerMap();
      this.reloadTiles();
    });
  }

  reloadTiles() {
    this.map.invalidateSize();
  }

  centerMap() {
    const coordinatesList: L.LatLng[] = [];
      this.heartBeats.forEach(h => coordinatesList.push(L.latLng(h.position.latitude, h.position.longitude)));

      const bounds = L.latLngBounds(coordinatesList);
      this.fitBounds = bounds;
  }

  onMapReady(map: L.Map) {
    this.map = map;
  }

  markPositions(): void {
    for ( let i = 0 ; i < this.heartBeats.length ; i++) {
      this.addMarker(this.heartBeats[i], (i + 1));
    }
  }

  addMarker(h: HeartBeat, position: number) {
    const newMarker = L.marker([h.position.latitude, h.position.longitude],
      {
        icon: new L.DivIcon({
          iconSize: [41, 51],
          popupAnchor:  [0, -51],
          className: 'my-div-icon',
          html: '<img class="icon-map-history" src="/assets/marker_empty.png"/>' +
                '<span class="leaflet-marker-icon number">' + position + '</span>'
        })
      }
    );
    this.markers.push(newMarker);
  }

  /**
   * Show battery only if received hearbeats containes battery level information
   */
  shouldShowBattery(): void {
    this.shouldShowBatteryColumn = this.heartBeats.filter(h => h.bikeBatteryLevel !== undefined).length > 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/bikes/bike-history/bike-history.component.ts